module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-13-fc2f42f4d8a17fff2e1be27508a7ebbd.jpg";